import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lc_ttop"
};
const _hoisted_2 = {
  style: {
    "padding-bottom": "50px"
  }
};
import { getCurrentInstance, reactive, ref, provide } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
/* 数据层 */

export default {
  __name: 'km',
  setup(__props) {
    const route = useRoute();
    const ids = ref(route.query.prBasetaskId);
    const {
      proxy
    } = getCurrentInstance();
    provide('project_id', route.query.id);
    // 基本信息组件值
    const addBaseInfo = ref();
    const lcButtons = ref();
    // 详情数据
    let data = reactive({
      baseInfo: {},
      height: 300,
      key: "",
      id: "",
      remark: ''
    });
    // 基本信息字段值
    let baseInfokeys = reactive({
      keyArry: ['sn', 'project_sn', 'name', 'required_time_text', 'status', 'leader_user_id', 'reviewer_user_id', 'task_status_text', 'examine_status_text', 'project_id', 'project_name', 'plan_start_time', 'plan_start_time_text', 'plan_end_time', 'plan_end_time_text', 'end_time_text', 't0_time_text']
    });
    /* 初始化 */
    getPageInfo();
    /* 方法层 */
    // 开模详情
    function getPageInfo(value) {
      proxy.$http.get('project/task/mold/info', {
        id: route.query.prBasetaskId
      }).then(res => {
        if (res.errno == 200) {
          data.baseInfo = JSON.parse(JSON.stringify(res.data));
          ids.value = res.data.id;
          data.remark = res.data.remark;
          // 驳回原因
          addBaseInfo.value.data.reject = res.data && res.data.reject ? res.data.reject : '';
          baseInfokeys.keyArry.forEach(it => {
            addBaseInfo.value.taskform[it] = res.data[it];
          });
        } else {
          ElMessage({
            type: 'success',
            message: res.errmsg
          });
        }
      });
    }
    //按钮组操作
    function btsEmit(value) {
      // 提交和审核先做保存的动作
      if (value == 'passBt' || value == 'submitBt') {
        handelSavePage(value);
      }
      // 保存
      if (value == 'saveBt') {
        handelSavePage();
      }
    }
    // 保存页面
    function handelSavePage(bttype) {
      proxy.$http.showLoading(false).post('project/task/mold/edit', {
        id: data.baseInfo.id,
        leader_user_id: addBaseInfo.value.taskform['leader_user_id'],
        reviewer_user_id: addBaseInfo.value.taskform['reviewer_user_id'],
        plan_start_time: addBaseInfo.value.taskform['plan_start_time_text'],
        plan_end_time: addBaseInfo.value.taskform['plan_end_time_text'],
        t0_time: addBaseInfo.value.taskform['t0_time_text'],
        remark: data.remark
      }).then(res => {
        if (res.errno == 200) {
          ElMessage({
            type: 'success',
            message: res.errmsg
          });
          if (bttype == 'submitBt') {
            lcButtons.value.thesubmit(bttype);
          }
          if (bttype == 'passBt') {
            lcButtons.value.thepass(bttype);
          }
          getPageInfo();
        } else {
          ElMessage({
            type: 'error',
            message: res.errmsg
          });
        }
      });
    }
    //富文本编辑器
    function inputContent(value) {
      data.remark = value;
    }
    return (_ctx, _cache) => {
      const _component_LcButtons = _resolveComponent("LcButtons");
      const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
      const _component_lctinymce = _resolveComponent("lctinymce");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "bg_white wrap_box lc_rw"
      }, {
        default: _withCtx(() => [_createVNode(_component_LcButtons, {
          ref_key: "lcButtons",
          ref: lcButtons,
          type: 2,
          onBtsEmit: _cache[0] || (_cache[0] = $event => btsEmit($event)),
          planStratTime: _unref(data).baseInfo.plan_start_time_text,
          ids: ids.value,
          projectName: _unref(data).baseInfo.project_name,
          reviewerUserId: _unref(data).baseInfo.reviewer_user_id,
          userId: _unref(data).baseInfo.leader_user_id,
          msg: _unref(data).baseInfo.msg,
          onGetPageInfo: getPageInfo,
          deppgetPageInfo: getPageInfo
        }, null, 8, ["planStratTime", "ids", "projectName", "reviewerUserId", "userId", "msg"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_lcBaseInfo, {
          ref_key: "addBaseInfo",
          ref: addBaseInfo,
          type: "taskInfo",
          kmT0tag: "km"
        }, null, 512)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "lc_ttop lc_bzt"
        }, "备注", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createBlock(_component_lctinymce, {
          id: _unref(data).id,
          ref: "editor",
          height: _unref(data).height,
          "cur-value": _unref(data).remark,
          onInput: inputContent,
          key: _unref(data).key
        }, null, 8, ["id", "height", "cur-value"]))])]),
        _: 1,
        __: [1]
      });
    };
  }
};